import { RefObject } from "react";
import { WaveformJSON } from "../Waveform.Parts";

// TEXT

// STYLES

// DATA

// TYPES
export type Props = {
  canvasRef: RefObject<HTMLCanvasElement | null>;
  waveform: WaveformJSON;
  width: number;
  height: number;
  currentTime: number;
  totalDuration: number;
  isHovering: boolean;
};

// CONSTANTS
export const MIN_BAR_SIZE = 2;
export const MIN_BAR_WIDTH = 1;
export const MIN_BAR_SPACING = 1;

// FUNCTIONS

// ASSETS
